import React, { Component } from 'react'
import firebase from '../../config/database'
import Indicator from '../Indicator'
import * as FontAwesome from 'react-icons/fa';
import * as MaterialIcons from 'react-icons/md';
import * as Typicons from 'react-icons/ti';
import * as Octicons from 'react-icons/go';
import * as Ionicons from 'react-icons/io';
import * as Feather from 'react-icons/fi';
import PropTypes from 'prop-types';

class Image extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      isLoading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitImageToFirebase = this.submitImageToFirebase.bind(this);
    this.saveImageLinkInFirebase = this.saveImageLinkInFirebase.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value
      });
    }
  }

  saveImageLinkInFirebase(link) {
    console.log(link);
    this.setState({ isLoading: false });
    this.props.updateAction(this.props.theKey, link);
  }

  submitImageToFirebase(value) {
    var _this = this;
    // Create a root reference
    var storageRef = firebase.app.storage().ref(this.props.path);
    var refFile = new Date().getTime() + ".jpg"

    // Create a reference to 'mountains.jpg'
    var newImageRef = storageRef.child(refFile);
    var stripedImage = value.substring(value.indexOf('base64') + 7, value.length);

    newImageRef.putString(stripedImage, 'base64').then(function (snapshot) {
      console.log('Uploaded a base64 string!');
      snapshot.ref.getDownloadURL().then(function (downloadURL) {
        _this.saveImageLinkInFirebase(downloadURL);
      });
    });
  }

  handleChange(e) {
    this.setState({ isLoading: true });
    e.preventDefault();
    console.log("Start processing ....")

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      console.log("Image is in base 64 now.. Upload it");
      this.setState({
        file: file,
        value: reader.result
      });
      this.submitImageToFirebase(reader.result)

    }

    reader.readAsDataURL(file)

  }
  getHandler(icon, edit) {
    var handler = MaterialIcons;
    if (icon.startsWith("Fa")) {
      handler = FontAwesome;
    } else if (icon.startsWith("Io")) {
      handler = Ionicons;
    } else if (icon.startsWith("Fi")) {
      handler = Feather;
    }
    var Element = handler[icon + ""];
    // console.log(Element);
    if (Element) {
      if (edit) {
        return (<div className="iconmargin"><Element color='black' size="30" /></div>);

      } else {
        return (<div className="iconmargin"><Element color='white' size="20" /></div>);
      }
    } else {
      return (<div />)
    }
    //
  }

  render() {
    var imgSrc = this.state.value && this.state.value.length > 4 ? this.state.value : "../../assets/img/image_placeholder.jpg";
    // var imgSrc = this.state.value;;

    // console.log("Image source");
    // console.log(imgSrc);
    if (imgSrc.length > 16 || imgSrc == "../../assets/img/image_placeholder.jpg") {
      return (
        <div className="col-md-12 fileinput fileinput-new text-center" data-provides="fileinputaa">
          <div className={"fileinput-new " + (this.props.wrapperClass ? this.props.wrapperClass : "thumbnail")}>
            <img src={imgSrc} alt="..." className={this.props.class} />
          </div>
          <div className="fileinput-preview fileinput-exists thumbnail"></div>
          <div className="col-md-12">
            <span className={"btn btn-rose btn-round btn-file"}>
              <span className="fileinput-new">Select image</span>
              <span className="fileinput-exists">Change</span>
              <input type="file" accept="image/*" style={{ width: '2000px' }} id={this.props.theKey} name={this.props.theKey} onChange={this.handleChange} />
            </span>
            <Indicator show={this.state.isLoading} />
            <a href="#pablo" className="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i className="fa fa-times"></i> Remove</a>
          </div>
        </div>
      )
    } else {
      return (

        <div className="col-md-12 fileinput fileinput-new text-center" data-provides="fileinputaa">
          <div className={"fileinput-new " + (this.props.wrapperClass ? this.props.wrapperClass : "thumbnail")}>
            {this.getHandler(imgSrc, true)}
          </div>
          <div className="fileinput-preview fileinput-exists thumbnail"></div>
          <div className="col-md-12">
            <span className={"btn btn-rose btn-round btn-file"}>
              <span className="fileinput-new">Change image</span>
              <span className="fileinput-exists">Change</span>
              <input type="file" accept="image/*" style={{ width: '2000px' }} id={this.props.theKey} name={this.props.theKey} onChange={this.handleChange} />
            </span>
            <Indicator show={this.state.isLoading} />
            <a href="#pablo" className="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i className="fa fa-times"></i> Remove</a>
          </div>
        </div>
      )
    }

  }
}
export default Image;

Image.propTypes = {
  updateAction: PropTypes.func.isRequired,
  theKey: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  class: PropTypes.string,
  wrapperClass: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/fields/Image.js